var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.layoutClass,style:(_vm.layoutStyle)},[_c('left-navigation-drawer'),_c('app-bar'),_c('page-content'),_c('right-navigation-drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }